title: Itinerary Templates
create:
  title: Create Itinerary Template
update:
  title: Update Itinerary Template
builder:
  addStop: Add Stop
  addDay: Add Day
stateTransitionLabel:
  DRAFT: Clone & Edit
  PUBLISHED: Publish
  ARCHIVED: Archive
